import axios from "axios";
import toast, { Toaster } from "react-hot-toast";

// API base URL — empty = relative paths, React dev-server proxy forwards /api/* to backend
const API_BASE_URL = process.env.REACT_APP_API_URL || "";

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { 
    "Content-Type": "application/json",
  },
  withCredentials: true,
  timeout: 300000,
});

// Request interceptor - add auth token
api.interceptors.request.use(
  (config) => {
    // Get token from localStorage (for local auth)
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API Error:", error.message);
    
    // Handle 401 - Unauthorized
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    
    // Handle 403 - Forbidden
    if (error.response?.status === 403) {
      toast.error('Access denied');
    }
    
    // Handle network errors
    if (!error.response) {
      toast.error('Network error - please check your connection');
    }
    
    return Promise.reject(error);
  }
);

export default api;
